export default ({
  state: {
    currencyData: {}
  },
  mutations: {
    setCurrencyData (state, payload) {
      state.currencyData = payload
    }
  },
  actions: {
    setCurrencyData ({commit}, payload) {
      commit('setCurrencyData', payload)
    }
  },
  getters: {
    currency (state) {
      return state.currencyData
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/expenses/index.js